export default __webpack_public_path__ + "static/media/longscreens-DBS.447cdd88.png";